import React from 'react';

interface IconGrainProps {
    width?: number | string;
    height?: number | string;
    color?: string;
}

const IconGrain: React.FC<IconGrainProps> = ({ width = 24, height = 24, color = 'black' }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="8" cy="8" r="2" fill={color} />
        <circle cx="16" cy="16" r="2" fill={color} />
        <circle cx="12" cy="12" r="1" fill={color} />
    </svg>
);

export default IconGrain;
